import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-navbar.mjs";
import { render } from "lit-html";
import { Hero } from "../../../managers/Hero.ts";
import { getHero, getLanguage } from "../../global.ts";

export class HbNavBar extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private hero = new Hero();
    private start: HTMLButtonElement;
    private onboard: HTMLButtonElement;

    private en: HTMLLIElement;
    private km: HTMLLIElement;
    private fi: HTMLLIElement;

    constructor() {
        super();
        render(template(null, getLanguage()), this);

        this.start = this.querySelector("#hb-navbar-start")!;
        this.onboard = this.querySelector("#hb-navbar-onboard")!;

        this.en = this.querySelector("#hb-navbar-language-en")!;
        this.km = this.querySelector("#hb-navbar-language-km")!;
        this.fi = this.querySelector("#hb-navbar-language-fi")!;
    }

    connectedCallback() {
        this.en.addEventListener("click", this.setLanguage.bind(this, "en"));
        this.km.addEventListener("click", this.setLanguage.bind(this, "km"));

        this.start.addEventListener("click", () => {
            window.location.hash =
                localStorage.getItem("training-1") === "true"
                    ? "#/onboard/training-1"
                    : "#/onboard/start";
        });

        this.onboard.addEventListener("click", () => {
            window.location.hash =
                localStorage.getItem("training-2") === "true"
                    ? "#/onboard/training-2"
                    : "#/onboard/begin";
        });

        this.heartbank.addAuthStateListener((user) => {
            render(template(user, getLanguage()), this);
        });
    }

    show() {
        this.classList.remove("hidden");
    }

    hide() {
        this.classList.add("hidden");
    }

    private async setLanguage(lang: string) {
        const currentUrl = new URL(window.location.href);
        if (this.heartbank.user) {
            const { languageCode } = getHero();
            if (lang !== languageCode) {
                await this.hero.updateLanguage(lang);
                //currentUrl.searchParams.delete("lang");
                //window.location.replace(currentUrl.toString()); // no history
                //setTimeout(() => window.location.reload(), 100);
            }
        }
        if (lang !== currentUrl.searchParams.get("lang")) {
            currentUrl.searchParams.set("lang", lang);
            window.location.href = currentUrl.toString(); // history
        }
    }
}
